<template>
    <div >
        
        <div class="help" v-if="typeConfiguration=='gg'">
            <s-button 
                icon="info" :theme="isRecommended ? 'is-small is-success' : 'is-small is-primary'" 
                :label="isRecommended ? 'Recommandé' : ''"
                @onclick="openHelp()"/>
        </div>
        <div class="configurationNotPossible"   v-if="!possibleOuPas">
        
        <div>
        Pas de configuration possible avec <b>{{nbPool}} poules</b> et {{this.nbQualifieCalcul}} qualifié(s)
        </div>
        </div>
        <div class="configuration" v-on:click="choice()"  v-if="possibleOuPas">
        
        <div>
        Configuration avec <b>{{nbPool}} poules</b>
        </div>
        <div>
            {{pool4}} Poules de 4 joueurs et {{pool3}} poules de 3 joueurs
            <div v-if="this.nbEquipeIdeal()>0">
                Il y aura {{nbEquipeIdeal()}} qualifiés : <i><b>{{ciblePhase(this.nbEquipeIdeal())}}</b></i>
                <div v-if="typeConfiguration=='classique'" class="nbQualifie">
                    <span v-if="this.nbQualifieCalcul>1">Les {{this.nbQualifieCalcul}} meilleurs de chaque poule qualifiés</span>
                    <span v-if="this.nbQualifieCalcul==1">Le meilleur de chaque poule qualifié</span>
                    <div v-if="this.resteQualifie>0">
                          complété avec  
                            <span v-if="this.resteQualifie>1">les {{this.resteQualifie}} meilleurs</span>
                            <span v-if="this.resteQualifie==1">le meilleur</span>
                           {{nbQualifieCalcul+1}}ème de toutes les poules  
                    </div>
                </div>
            </div>
        </div>
        </div>
       
        <s-modal 
            :open="infoConfiguration && typeConfiguration=='classique'"
            @close="infoConfiguration = false"
            title="Info sur cette configuration"
            id="infoConfigurationClassique"
            :close="true"
        >
            Si vous choisissez cette configuration, nous vous proposons d'organiser le tournoi comme suit :<br/>
            Après les poules :<br/>
             Vous avez {{nbPool*2}} équipes qualifiées</br>
            
        </s-modal>
        <s-modal 
            :open="infoConfiguration && typeConfiguration=='gg'"
            @close="infoConfiguration = false"
            title="Info sur cette configuration"
            id="infoConfiguration"
            :close="true"
        >
           Si vous choisissez cette configuration, nous vous proposons d'organiser le tournoi comme suit :<br/>
            Après les poules :<br/>
            <b>- Faites une première partie éliminatoire avec les {{nbPool*2}} équipes qualifiées
            <br/>- Puis faites un cadrage<hr/></b>
            A l'issue la partie éliminatoire, il restera {{nbPool}} équipes<br/>
            L'objectif du cadrage est d'éliminer {{equipesDelta}} équipe(s) !<br/>
            L'idée est d'arriver à {{nbPool - equipesDelta}} équipes pour pouvoir faire des {{ciblePhase(nbPool - equipesDelta)}}
            <br/>Le cadrage comportera donc {{equipesDelta*2}} équipes tirées au hasard parmis les {{nbPool}}<br/>
            <span v-show="nbPool - equipesDelta*2==1">
                Il n'y aura qu'une équipe qui ne participera pas au cadrage et sera directement qualifiée
            </span>
            <span v-show="nbPool - equipesDelta*2>1">
                Il y aura donc {{nbPool - equipesDelta*2}} équipes qui ne participeront pas au cadrage et seront directement qualifiées
            </span>
        </s-modal>
         <s-info 
            :open="helpRecommande && typeConfiguration=='classique'"
            @close="helpRecommande = false"
            title="Configuration recommandé"
            :big="true"
            id="infoRecommandeClassique"
        >
            Cette configuration est recommandé car elle vous permet d'avoir {{jsonChampionnat.howNbPools.nbEquipeCible}} équipes qualifiées
            et de partir en {{ciblePhase(jsonChampionnat.howNbPools.nbEquipeCible)}}  tout de suite à l'issu des poules<br/>
            Pas besoin de faire de partie éliminatoire ni de cadrage
        </s-info>
        <s-info 
            :open="helpRecommande && typeConfiguration=='gg'"
            @close="helpRecommande = false"
            title="Configuration recommandé"
            :big="true"
            id="infoRecommande"
        >
            Cette configuration est recommandé car elle vous permet d'avoir {{jsonChampionnat.howNbPools.nbEquipeCible}} équipes qualifiées
            et de partir en {{ciblePhase(jsonChampionnat.howNbPools.nbEquipeCible)}}  tout de suite à l'issu des poules<br/>
            Pas besoin de faire de partie éliminatoire ni de cadrage
        </s-info>
    </div>
</template>
<script>
export default {
    props: ["jsonChampionnat", "typeConfiguration","nbQualifie"],
    data() {
        return {
            helpRecommande: false,
            infoConfiguration: false
        }
    },
    methods: {
        choice() {
            this.$emit("choiceConfiguration", this.nbPool, this.resteQualifie);
        },
        openHelp() {
            this.helpRecommande = false;
            this.infoConfiguration = false;
            
            if (this.isRecommended)
                this.helpRecommande= true;
            else
                this.infoConfiguration = true;
        },
        ciblePhase(nb) {
            if (nb!=null) {
                switch (nb) {
                     case 2 : 
                        return "Finale";
                        break;
                    case 4 : 
                        return "Demi finale";
                        break;
                    case 8 : 
                        return "Quart de final";
                        break;
                    case 16 : 
                        return "8ème de final";
                        break;
                    case 32 : 
                        return "16ème de final";
                        break;
                    case 64 : 
                        return "32ème de final";
                        break;
                    case 128 : 
                        return "64ème de final";
                        break;
                    case 256 :
                        return "128ème de final";
                        break;
                    case 512 :
                        return "512ème de final";
                        break;
                }
            }
            return "";
        },
        nbEquipeIdeal () {
           var nbEquipes = this.nbPool*this.nbQualifieCalcul;
           if (nbEquipes<2)
                return -1;
            else if (nbEquipes > 218)
                return 512
            else if (nbEquipes > 64)
                return 218
            else if (nbEquipes > 32)
                return 64
            else if (nbEquipes > 16)
                return 32
            else if (nbEquipes > 8)
                return 16
            else if (nbEquipes > 4)
                return 8
            else if (nbEquipes > 2)
                return 4
            else
                return 2
        }
    },
    computed: {
        possibleOuPas() {
            if (typeof(this.typeConfiguration)=="undefined")
                return true;
            else if (this.typeConfiguration == "gg")
                return true;
            else if (this.nbQualifieCalcul==4 && this.resteQualifie>0)
                return false;
            else
                return this.resteQualifie <= this.nbPool;
            
        },
        nbQualifieCalcul() {
            if (typeof(this.nbQualifie)=="undefined")
                return 2;
            else
                return this.nbQualifie
        },
        equipesDelta() {
           return this.jsonChampionnat.equipeIdeal;
        },
        isRecommended() {
            return this.jsonChampionnat.howNbPools.manqueNbPool==0
        },
        pool4() {
            var nbPool4 = 0;
            this.jsonChampionnat.forEach(pool=>{
                if (pool.joueurs.length==4)
                    nbPool4++;
            })
            return nbPool4;
        },
        pool3() {
            var nbPool3 = 0;
            this.jsonChampionnat.forEach(pool=>{
                if (pool.joueurs.length==3)
                    nbPool3++;
            })
            return nbPool3;
        },
        nbPool() {
            return this.jsonChampionnat.length;
        },
        resteQualifie() {
            var reste = this.nbEquipeIdeal() - (this.nbQualifieCalcul * this.nbPool);
            return reste;
        },
    }
}
</script>
<style scoped>
    .configurationNotPossible {
        border: thin solid black;
        padding: 10px;
        color: black;
        margin-top: 10px;
        border-radius: 10px;
        background-color: gray;
        width: 100%;
    }
    .configuration {
        border: thin solid black;
        padding: 10px;
        color: black;
        margin-top: 10px;
        border-radius: 10px;
       
        width: 100%;
    }
    .configuration:hover {
        background-color: rgb(203, 233, 158);
        cursor: pointer;
    }
    .recommande {
        background-color: rgb(108, 172, 12);
        color: white;
        margin-top: 10px;
        font-weight: bolder;
        border-radius: 10px;
        padding: 5px;
    }
    .help {
        float:right;
        text-align:right; 
        margin-right: 5px;
    }
    .nbQualifie {
        padding: 5px;
        font-style: italic;
    }
</style>